
import { Injectable } from '@angular/core';
import { GlobalObjectsService } from 'src/app/shared/services/global-objects.service';


@Injectable({
    providedIn: 'root'
})
export class AiUtilitiesService {
    constructor(private readonly globalObjectsService: GlobalObjectsService) { }

    createBeneficiaryAllocation(beneficiariesData: any[]): any[] {
        let beneficiaryAllocationList: any[] = [];
        let products: any[] = [];
        this.globalObjectsService.Products.pipe().subscribe(p => {
            products = p || [];
            // Place the rest of your mergeData logic here so it only runs after products are loaded
            if (beneficiariesData == null || beneficiariesData.length == 0) {
                return;
            }
            beneficiariesData.forEach((lineAllocation, index: number) => {
                // Filtering out the future dates
                if ((new Date(lineAllocation.recordEffective) > new Date(new Date().setHours(0, 0, 0, 0)))) {
                    return;
                }
                let newLineItem = {
                    lineName: lineAllocation.lineName,
                    icon: "",
                    allocationCountPrimary: 0,
                    allocationCountContingent: 0,
                    collectIrrevocableStatus: lineAllocation.collectIrrevocableStatus,
                    beneficiaryList: [],
                    lineAllocation: lineAllocation,
                    plan: undefined,
                    line_RecordID: lineAllocation.line_RecordID,
                    beneficiariesRequired: lineAllocation.beneficiariesRequired
                };

                lineAllocation.allocationBeneficiaries.forEach(allocationBeneficiary => {
                    if (allocationBeneficiary.beneficiaryType == 1) {
                        newLineItem.allocationCountPrimary++;
                    }
                    if (allocationBeneficiary.beneficiaryType == 2) {
                        newLineItem.allocationCountContingent++;
                    }
                    newLineItem.beneficiaryList.push({ ...allocationBeneficiary });
                });

                let p = products.find(x => x.line_GUID == lineAllocation.line_RecordID);
                if (p?.icon2) {
                    newLineItem.icon = p?.icon2;
                }

                /**
                 * Creating the object for the plan
                 */
                newLineItem.plan = {
                    recordID: lineAllocation.benefitPlan_RecordID,
                    collectContingentBeneficiaries: lineAllocation.collectContingentBeneficiaries,
                    collectIrrevocableStatus: lineAllocation.collectIrrevocableStatus
                }

                const indexOfAllocationList = beneficiaryAllocationList?.findIndex(x => x?.line_RecordID == newLineItem?.line_RecordID);
                if (indexOfAllocationList != -1) {
                    Object.assign(beneficiaryAllocationList[indexOfAllocationList], newLineItem);
                } else {
                    beneficiaryAllocationList.push(newLineItem);
                }
            });

        }).unsubscribe();

        return beneficiaryAllocationList;


    }
}
   
